import React from "react";
import { ImportDocumentPanel } from "../../components/document/ImportDocumentPanel";
import { CoRetrieveDocumentData } from "../../components/generic/CoRetrieveDocumentData";
import { UserFunctionEnum } from "../../api/models/user-function-enum";
import { UnauthorizedError } from "../../components/generic/UnauthorizedError";
import { ProtectedComponent } from "../../components/wrappers/ProtectedComponent";

export const ImportDocumentPage: React.FunctionComponent = () => {
  return (
    <ProtectedComponent userFunction={UserFunctionEnum.MENU_IMPORT_DOCUMENT} errorComponent={<UnauthorizedError />}>
      <CoRetrieveDocumentData>
        {({ coObject }) => <ImportDocumentPanel currentlyOpenedDocumentId={coObject?.documentId} />}
      </CoRetrieveDocumentData>
    </ProtectedComponent>
  );
};
